import getWithToken from './base/get-with-token'

const getMapDataBom = getWithToken('/map-data/bom')

export default getMapDataBom